import React from "react";
import moment from 'moment';
import MultiSelectDropdown from "../dropdown/MultiSelectDropdown.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ModalBasic from "../../pages/component/ModalBasic.js";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const SecondPageReceiptPaymentEntry = (props) => {
    return (
        <>
            <div className="item-form mb-4">
                <div className="item-grp flex gap-2.5 mb-2.5">
                    <div className="input-grp w-full">
                        <label>Voucher No</label>
                        <input
                            type="text"
                            id="voucherNo"
                            name="voucherNo"
                            className="inputFocus"
                            autocomplete="off"
                            disabled
                            value={props.accountDetails.voucherNo}
                            onChange={(event) =>
                                props.handleChange(event, "voucherNo", "accountDetails")
                            }
                        />

                    </div>
                    <div className="input-grp w-full">
                        <label>Date</label>
                        <input
                            type="date"
                            id="date"
                            name="date"
                            className={`inputFocus ${props.validState?.error?.date ? "errorInput" : ""}`}
                            autocomplete="off"
                            value={props.accountDetails.date}
                            onChange={(event) =>
                                props.handleChange(event, "date", "accountDetails")
                            }
                        />
                        {/* <ValidationText error={props.validState.error.date} /> */}
                    </div>
                    <div className="input-grp min-w-[40%]">
                        <label>Party Name</label>
                        <MultiSelectDropdown
                            drpIdentity="partyId"
                            options={props.partyDropdownList}
                            className={` ${props.validState?.error?.partyId ? "errorInput" : ""}`}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                props.setFilterParameters(selected, "partyId")
                            }
                            allowSelectAll={false}
                            value={props.partyDropdownList.filter(
                                (party) =>
                                    party.value === props.accountDetails.partyId
                            )}
                        />
                        {/* <ValidationText error={props.validState.error.partyId} /> */}
                    </div>
                    <div className="input-grp min-w-[25%]">
                        <label>Closing Balance</label>
                        <input
                            type="text"
                            id="closingBalance"
                            name="closingBalance"
                            className="inputFocus"
                            autocomplete="off"
                            disabled
                            value={props.accountDetails.closingBalance}
                            onChange={(event) =>
                                props.handleChange(event, "closingBalance", "accountDetails")
                            }
                        />
                    </div>

                </div>

                <div className="item-grp flex gap-2.5 mb-2.5">
                    <div className="input-grp min-w-[30%]">
                        <label>Cash/Bank Name</label>
                        <MultiSelectDropdown
                            drpIdentity="bankId"
                            className={` ${props.validState?.error?.bankId ? "errorInput" : ""}`}
                            options={props.daybookList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                                props.setFilterParameters(selected, "bankId")
                            }
                            allowSelectAll={false}
                            value={props.accountDetails.bankId && props.daybookList.filter(
                                (party) =>
                                    party.value === props.accountDetails.bankId
                            )}
                        />
                        {/* <ValidationText error={props.validState.error.bankId} /> */}
                    </div>
                    <span className='mt-[3.5px] border-l-2'></span>
                    <div className="input-grp min-w-[30%]">
                        {props.pageName === "receiptEntry" ? <label>Party Bank Name</label> : props.pageName === "paymentEntry" ? <label>Pay To</label> : ""}
                        <input
                            type="text"
                            id="partyBankNameOrPayto"
                            name="partyBankNameOrPayto"
                            className="inputFocus"
                            autocomplete="off"
                            value={props.accountDetails.partyBankNameOrPayto}
                            onChange={(event) =>
                                props.handleChange(event, "partyBankNameOrPayto", "accountDetails")
                            }
                        />
                    </div>


                    <div className="input-grp w-full">
                        <label>Cheque No.</label>
                        <input
                            type="number"
                            id="chqNo"
                            name="chqNo"
                            className="inputFocus"
                            autocomplete="off"
                            value={props.accountDetails.chqNo}
                            onChange={(event) =>
                                props.handleChange(event, "chqNo", "accountDetails")
                            }
                        />
                    </div>
                    {props.pageName === 'paymentEntry' ?
                        <div className="input-grp w-full">
                            <label>Amount</label>
                            <input
                                type="number"
                                id="debitAmount"
                                name="debitAmount"
                                className={`inputFocus ${props.validState?.error?.debitAmount ? "errorInput" : ""}`}
                                autocomplete="off"
                                value={props.accountDetails.debitAmount}
                                onChange={(event) =>
                                    props.handleChange(event, "debitAmount", "accountDetails")
                                }
                            />
                            {/* <ValidationText error={props.validState.error.debitAmount} /> */}
                        </div>
                        :
                        <div className="input-grp w-full">
                            <label>Amount</label>
                            <input
                                type="number"
                                id="creditAmount"
                                name="creditAmount"
                                className={`inputFocus ${props.validState?.error?.creditAmount ? "errorInput" : ""}`}
                                autocomplete="off"
                                value={props.accountDetails.creditAmount}
                                onChange={(event) =>
                                    props.handleChange(event, "creditAmount", "accountDetails")
                                }
                            />
                            {/* <ValidationText error={props.validState.error.creditAmount} /> */}
                        </div>
                    }
                </div>
                <div className="item-grp flex gap-2.5 mb-2.5">
                    <div className="input-grp w-full">
                        <label>Narration</label>
                        <input
                            type="text"
                            id="narration1"
                            name="narration1"
                            className="inputFocus"
                            autocomplete="off"
                            value={props.accountDetails.narration1}
                            onChange={(event) =>
                                props.handleChange(event, "narration1", "accountDetails")
                            }
                        />
                    </div>
                    <div className="input-grp w-full">
                        <label>Narration</label>
                        <input
                            type="text"
                            id="narration2"
                            name="narration2"
                            className="inputFocus"
                            autocomplete="off"
                            value={props.accountDetails.narration2}
                            onChange={(event) =>
                                props.handleChange(event, "narration2", "accountDetails")
                            }
                        />
                    </div>
                </div>
                <div className="item-grp flex  gap-2.5 mb-2.5">
                    <div className="input-grp w-full">
                        <label>Narration</label>
                        <input
                            type="text"
                            id="narration3"
                            name="narration3"
                            className="inputFocus"
                            autocomplete="off"
                            value={props.accountDetails.narration3}
                            onChange={(event) =>
                                props.handleChange(event, "narration3", "accountDetails")
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="item-grp py-2.5" style={{ borderTop: "0.5px solid  #8080804d", borderBottom: "0.5px solid #8080804d" }}>
                <div
                    style={{
                        fontSize: "17px",
                        fontWeight: "700",
                        marginBottom: "10px",
                        color: "#4b4b4b"
                    }}
                >
                    Adjustment Details
                </div>
                <div className="item-grp mb-3 flex gap-2.5 ">
                    <div className="input-grp w-full">
                        <label>Adj. Type</label>
                        <select
                            name="adjType"
                            value={props.adjustmentDetails.adjType}
                            disabled={props.isDisabledAdjustmentFields}
                            className={` ${props.validStateForAdjustmentDetails?.error?.adjType ? "errorInput" : ""}`}
                            onChange={(event) =>
                                props.handleDropDownChange(
                                    event,
                                    "adjType",
                                    "adjustmentDetails"
                                )
                            }
                        >
                            <option>Select</option>
                            {props.adjTypeList.map((x, key) => (
                                <option key={key} value={x.adjType}>
                                    {x.adjType}
                                </option>
                            ))}
                        </select>
                        {/* <ValidationText error={props.validStateForAdjustmentDetails.error.adjType} /> */}
                    </div>
                    <div className="input-grp w-full">
                        <label>Invoice No.</label>
                        <input
                            type="text"
                            id="invoiceNo"
                            name="invoiceNo"
                            autoComplete="off"
                            // disabled={props.isDisabledAdjustmentFields}
                            disabled
                            className="inputFocus"
                            value={props.adjustmentDetails.invoiceNo}
                            onChange={(event) =>
                                props.handleChange(event, "invoiceNo", "adjustmentDetails")
                            }
                        />
                    </div>
                    <div className="input-grp w-full">
                        <label>Invoice Amount</label>
                        <input
                            type="number"
                            id="invoiceAmount"
                            name="invoiceAmount"
                            autoComplete="off"
                            className="inputFocus"
                            // disabled={props.isDisabledAdjustmentFields}
                            disabled
                            value={props.adjustmentDetails.invoiceAmount}
                            onChange={(event) =>
                                props.handleChange(event, "invoiceAmount", "adjustmentDetails")
                            }
                        />
                    </div>
                    <div className="input-grp w-full">
                        <label>Adj. Amount</label>
                        <input
                            type="number"
                            id="adjAmount"
                            name="adjAmount"
                            autoComplete="off"
                            className={` ${props.validStateForAdjustmentDetails?.error?.adjAmount ? "errorInput" : ""}`}
                            disabled={props.isDisabledAdjustmentFields}
                            value={props.adjustmentDetails.adjAmount}
                            onChange={(event) =>
                                props.handleChange(event, "adjAmount", "adjustmentDetails")
                            }
                        />
                        {/* <ValidationText error={props.validStateForAdjustmentDetails.error.adjAmount} /> */}
                    </div>
                    <div className="input-grp w-full">
                        <label>Pending Amount</label>
                        <input
                            type="number"
                            id="pendingAmount"
                            name="pendingAmount"
                            autoComplete="off"
                            className="inputFocus"
                            disabled
                            value={props.accountDetails.pendingAmount}
                        />
                    </div>
                </div>
                <div className="flex gap-2.5 ">
                    <div className="itemList-table w-[50%]">
                        <div className="table-container" style={{ height: "26vh" }}>
                            <table className="itemList">
                                <thead>
                                    <tr>
                                        <td className="w-[25%]">Adj. Type</td>
                                        <td className="w-[25%]">Ref. No.</td>
                                        <td className="w-[25%]">Amount</td>
                                        <td className="w-[25%] !text-center">Action</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.adjustmentDetailsList &&
                                        props.adjustmentDetailsList.length > 0
                                        ? props.adjustmentDetailsList.map((item, key) => (
                                            <tr key={key}>
                                                <td>{item.adjType}</td>
                                                <td>{item.invoiceNo}</td>
                                                <td>{item.adjAmount}</td>
                                                <td className="!text-center">
                                                    <button
                                                        className="search-btn"
                                                        onClick={() => props.editAdjustmentDetails(key, item)}
                                                    >
                                                        <FontAwesomeIcon icon={faPen} />
                                                    </button>
                                                    <button
                                                        className="cancel-btn"
                                                        onClick={() => props.deleteAdjustmentDetails(key)}
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="btn-grp mb-auto">
                        {props.isadjustmentDetailsEditing ?
                            <button
                                className="add-btn mb-auto"
                                disabled={props.isDisabledAdjustmentFields}
                                onClick={props.saveDatainAdjustmentTable}
                            >
                                Save
                            </button>
                            :
                            <button
                                className="add-btn mb-auto"
                                disabled={props.isDisabledAdjustmentFields}
                                onClick={props.saveDatainAdjustmentTable}
                            >
                                Add
                            </button>
                        }
                        <button
                            className="cancel-btn mb-auto"
                            onClick={() => { props.resetAdjustmentDetails() }}
                            disabled={props.isDisabledAdjustmentFields}
                        >
                            Cancel
                        </button>
                        {/* <div className="input-grp w-full">
                            <label>Pending Amount</label>
                            <input
                                type="number"
                                id="pendingAmount"
                                name="pendingAmount"
                                autoComplete="off"
                                className="inputFocus"
                                disabled
                                value={props.accountDetails.pendingAmount}
                            />
                        </div> */}
                    </div>
                </div>
            </div >

            <div className="btn-grp mt-4">
                <button className="add-btn" onClick={props.addEditEntry} disabled={props.isLoading}> {props.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}</button>
                <button className="cancel-btn" onClick={props.openGridView} disabled={props.isLoading}>Cancel</button>
                {props.pageName === "paymentEntry" && props.isChequePrint ? <button className="print-btn" onClick={props.printCheque}>Cheque Print</button> : null}
            </div>

            <ModalBasic
                id="purchase-order-material-list"
                modalOpen={props.setPendingInvoiceModal}
                setModalOpen={() => props.setOpenModel()}
                title="Pending Invoices"
            >
                <div className="itemList-table">
                    <div className="table-container">

                        <table className="itemList">
                            <thead>
                                <tr>
                                    <td style={{ width: '10%' }}>Invoice No</td>
                                    <td style={{ width: '35%' }}>Date</td>
                                    <td style={{ width: '35%' }}>Pending Amount</td>
                                    <td style={{ width: '10%', textAlign: 'center' }}>Action</td>
                                </tr>
                            </thead>
                            {props.pendingInvoiceList && props.pendingInvoiceList.length > 0 ? (
                                props.pendingInvoiceList.map((item, key) => (
                                    <tbody key={key}>
                                        <tr>
                                            <td>{item.invoiceNo}</td>
                                            <td>{moment(item.invoiceDate).format('DD MMM YYYY')}</td>
                                            <td>{item.pendingAmount}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <button
                                                    className="search-btn"
                                                    onClick={() => props.selectInvoiceFromPendingInvoice(item)}
                                                >
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                ))
                            ) : (
                                <tbody className="validation-body">
                                    <tr>
                                        <td
                                            colSpan={6}
                                            style={{ textAlign: "center", fontSize: "16px" }}
                                        >
                                            No Records Found
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </ModalBasic>
        </>
    );
};
export default SecondPageReceiptPaymentEntry;